import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { PaymentService } from 'src/app/_services/payment.service';
import { VendorService } from 'src/app/_services/vendor.service';
import { ServiceTypeService } from 'src/app/_services/service-type.service';

@Component({
  selector: 'app-payment-link-information',
  templateUrl: './payment-link-information.component.html',
  styleUrls: ['./payment-link-information.component.css'],
  providers: [DatePipe]
})
export class PaymentLinkInformationComponent implements OnInit {

  constructor(
    public loginService: LoginService,
    public authService: AuthService,
    public paymentService: PaymentService,
    public route: ActivatedRoute,
    public vendorService : VendorService,
    public serviceTypeService : ServiceTypeService,    
    private datePipe: DatePipe
  ) { }
  custTrackingNo:any;
  custID = this.authService.getRegistredUserDetails().customerId;
  PaymentServiceTypes: any[]


  ngOnInit(): void {
    const token = this.authService.getToken();
    this.paymentService.paymentReqDetails(this.route.snapshot.params.paymentRequestId)
      .subscribe((result) => {
        this.custTrackingNo=result['custTrackingNo'];
        this.vendorService.vendorDetailsByName(result['vendorId'],this.custID, token).subscribe
          ((response) => {
            console.log(response);
            this.businessTypeForm = new FormGroup(
              {
                //business info
                serviceType : new FormControl(result['paymentServiceTypeId']),
                serviceDate: new FormControl(this.datePipe.transform(result['serviceDate'], 'dd-MM-yyyy')),
                serviceCode: new FormControl(result['serviceCode']),
                serviceDesc: new FormControl(result['serviceDescription']),
                serviceCharges: new FormControl(result['serviceCharge']),

                //service info
                // lenderName: new FormControl(result['partyName']),
                // lenderId: new FormControl(''),
                vendorNameId: new FormControl(result['vendorId']==null?'':result['vendorId']),
                loanId: new FormControl(result['altCustTrkNo']),
                propertyStreet: new FormControl(result['payeeAddress']),
                propertyCity: new FormControl(result['payeeCity']),
                propertyLandmark: new FormControl(result['payeeLandmark']),
                propertyState: new FormControl(result['payeeState']),
                propertyZip: new FormControl(result['payeeZip']),
                propertyCountry: new FormControl(''),

                //vendor info
                vendorName: new FormControl(result['vendorId']==null?'':result['vendorId']),
                vendorId: new FormControl(response['vendorRegistrationId']==null?'':response['vendorRegistrationId']),
                vendorAddress: new FormControl(response['addr1']),
                vendorEmail: new FormControl(response['email']),

                //payee information
                payeeType: new FormControl(result['payeeType']),
                firstName: new FormControl(result['payeeNameFirst']),
                lastName: new FormControl(result['payeeNameLast']),
                company: new FormControl(result['payeeCompany']),
                address: new FormControl(''),
                state: new FormControl(result['payeeState']),
                city: new FormControl(''),
                zipCode: new FormControl(result['payeeZip']),
                country: new FormControl(''),
                phoneNumber: new FormControl(result['payeePhone']),
                email: new FormControl(result['payeeEmail'])
              })
          })
      })

      this.serviceTypeService.getServiceTypeList(token).subscribe((response) => {
        this.PaymentServiceTypes = response;
        console.log(response)
      })
  }

  businessTypeForm: FormGroup = new FormGroup(
    {
      //business info
      serviceType : new FormControl(''),
      serviceDate: new FormControl(''),
      serviceCode: new FormControl(''),
      serviceDesc: new FormControl(''),
      serviceCharges: new FormControl(''),

      //service info
      // lenderName: new FormControl(''),
      // lenderId: new FormControl(''),
      vendorNameId: new FormControl(''),
      loanId: new FormControl(''),
      propertyStreet: new FormControl(''),
      propertyCity: new FormControl(''),
      propertyLandmark: new FormControl(''),
      propertyState: new FormControl(''),
      propertyZip: new FormControl(''),
      propertyCountry: new FormControl(''),
      reason : new FormControl(''),

      //vendor info
      vendorName: new FormControl(''),
      vendorId: new FormControl(''),
      vendorAddress: new FormControl(''),
      vendorEmail: new FormControl(''),

      //payee information
      payeeType: new FormControl(''),
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      company: new FormControl(''),
      address: new FormControl(''),
      state: new FormControl(''),
      city: new FormControl(''),
      zipCode: new FormControl(''),
      country: new FormControl(''),
      phoneNumber: new FormControl(''),
      email: new FormControl('')
    })

    scrollToSection(sectionId: string): void {
      const targetElement = document.getElementById(sectionId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    containsAgent(): boolean {
      const service = this.PaymentServiceTypes.find(service => service.paymentServiceTypeId === this.businessTypeForm.value.serviceType);
      return service && (service.serviceType.toLowerCase().includes('agent')||service.serviceType.toLowerCase().includes('fund'));
    }
}

